const emptyIfNull = (value) => (value == null ? "" : value);

/** Production by default; override with REACT_APP_ZATCA_API_BASE for local dev (e.g. http://localhost:8084). */
export function getZatcaApiBaseUrl() {
  const envBase = process.env.REACT_APP_ZATCA_API_BASE;
  if (envBase && String(envBase).trim()) {
    return String(envBase).replace(/\/$/, "");
  }
  return "https://api-pos.hulmsolutions.com";
}

export function getZatcaFetchUrl(tenantId) {
  return `${getZatcaApiBaseUrl()}/api/fatoora/${encodeURIComponent(tenantId)}`;
}

export function getZatcaPosCheckoutUrl(tenantId) {
  return `${getZatcaFetchUrl(tenantId)}/pos/checkout`;
}

export function getZatcaB2bCheckoutUrl(tenantId) {
  return `${getZatcaFetchUrl(tenantId)}/b2b/checkout`;
}

export function getZatcaPhase1B2cGenerateUrl(tenantId) {
  return `${getZatcaFetchUrl(tenantId)}/phase1/b2c/generate`;
}

export function getZatcaPhase1B2bGenerateUrl(tenantId) {
  return `${getZatcaFetchUrl(tenantId)}/phase1/b2b/generate`;
}

export function getZatcaInvoicesPreviewUrl(tenantId, { limit = 20, offset = 0 } = {}) {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  return `${getZatcaFetchUrl(tenantId)}/invoices/preview?${params.toString()}`;
}

export function getZatcaInvoiceByReferenceUrl(tenantId, reference) {
  const params = new URLSearchParams();
  params.set("reference", String(reference));
  return `${getZatcaFetchUrl(tenantId)}/invoices/by-reference?${params.toString()}`;
}

export function buildZatcaFormDefaults(tenantId = "") {
  return {
    tenantId,
    companyName: tenantId,
    email: "",
    phone: "",
    name: "",
    vatNumber: "",
    crNumber: "",
    taxNumber: "",
    address: {
      street: "",
      buildingNumber: "",
      district: "",
      city: "",
      postalCode: "",
      country: "SA",
    },
  };
}

/** Map GET /api/fatoora/{tenantId} response into form fields. */
export function mapZatcaApiToFormData(data, tenantId = "") {
  if (!data) {
    return buildZatcaFormDefaults(tenantId);
  }

  return {
    tenantId: emptyIfNull(data.tenantId) || tenantId,
    companyName: emptyIfNull(data.companyName) || tenantId,
    email: emptyIfNull(data.email),
    phone: emptyIfNull(data.phone),
    name: emptyIfNull(data.name),
    vatNumber: emptyIfNull(data.vatNumber),
    crNumber: emptyIfNull(data.crNumber),
    taxNumber: emptyIfNull(data.taxNumber) || emptyIfNull(data.vatNumber),
    address: {
      street: emptyIfNull(data.address?.street),
      buildingNumber: emptyIfNull(data.address?.buildingNumber),
      district: emptyIfNull(data.address?.district),
      city: emptyIfNull(data.address?.city),
      postalCode: emptyIfNull(data.address?.postalCode),
      country: emptyIfNull(data.address?.country),
    },
  };
}

export function buildZatcaSetupPayload(formData, { companyName, phone } = {}) {
  const tenantId = formData.tenantId || companyName || "";
  const resolvedCompanyName = formData.companyName || companyName || "";
  const vatNumber = formData.vatNumber || "";

  return {
    tenantId,
    companyName: resolvedCompanyName,
    email: formData.email || "",
    name: formData.name || resolvedCompanyName,
    vatNumber,
    crNumber: formData.crNumber || "",
    taxNumber: formData.taxNumber || vatNumber,
    phone: formData.phone || phone || "",
    address: {
      street: formData.address?.street || "",
      buildingNumber: formData.address?.buildingNumber || "",
      district: formData.address?.district || "",
      city: formData.address?.city || "",
      postalCode: formData.address?.postalCode || "",
      country: formData.address?.country || "SA",
    },
  };
}

export const processZATCAInvoice = (tenantId, data, token) => {
  return fetch(getZatcaPosCheckoutUrl(tenantId), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (token || "my-token"),
    },
    body: JSON.stringify(data),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  });
};

export const getZatcaInformation = (tenantId, token) => {
  if (!tenantId) {
    return Promise.reject(new Error("Tenant ID is required to fetch ZATCA data."));
  }

  return fetch(getZatcaFetchUrl(tenantId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (token || "my-token"),
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else if (response.status === 404) {
      return null;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  });
};

export const setupZatcaInformation = (payload, token) => {
  return fetch("https://api-pos.hulmsolutions.com/api/setup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (token || "my-token"),
    },
    body: JSON.stringify(payload),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  });
};
